import React from "react";
import { Card, CardHeader, CardContent } from "@mui/material";
import UnscheduledAppointments from "./UnscheduledAppoitnments";

const UnscheduledAppointmentsWidget: React.FC= () => {
  return (
    <Card
      sx={{
        display: "flex",
        flexDirection: "column",
        minHeight: "440px",
        maxHeight: "440px",
      }}
    >
      <CardHeader title="Nicht geplante Termine" />
      <CardContent
        sx={{
          flex: 1,
          minHeight: 0,
          overflow: "hidden",
          display: "flex",
          flexDirection: "column",
          p: 0,
          m: 0,
        }}
      >
        <UnscheduledAppointments />
      </CardContent>
    </Card>
  );
};

export default UnscheduledAppointmentsWidget;
